import flickerTextReveal from './flickerTextReveal';
import { maskRevealText, maskReveal } from './maskReveal';

export default {
  flickerTextReveal,
  maskRevealText,
  maskReveal,
};
